import React, { useEffect, useState } from 'react'
import { Checkbox, Form, Icon, Input, message } from 'antd'
import { connect } from 'react-redux'
import { getLastReadingTimeBased, getVerificationReadingRecord } from '../../appRedux/actions/AssetReading'
import { getAssetMeterDetail } from '../../appRedux/actions/Meter'
import moment from 'moment'

const Mileage = React.memo(function Mileage({ key, visible, form, meterUnits, selectedAsset, selectedDate, meterReadings, handleChange, isDateBased, ...props }) {
  // const [unit, setUnit] = useState('')
  const [currentMeterReadings, setCurrentMeterReadings] = useState(null)

  // const { visible, form, filterData, selectedAsset, selectedDateTime, meterReadings, handleChange, isDateBased } = props
  const { getFieldDecorator } = form
  // const { meterUnits } = filterData || {}

  const newMeterUnits = (meterUnits && meterUnits.data && meterUnits.data.data) || []

  const getMeterId = (meterValue) => {
    if (!meterValue) return null
    return meterValue && meterValue._id ? meterValue._id.toString() : meterValue.toString()
  }

  useEffect(() => {
    const normalizedReadings = (meterReadings || []).map((readingItem) => ({
      ...readingItem,
      meter: getMeterId(readingItem && readingItem.meter),
      isFaultyMeter: !!(readingItem && readingItem.isFaultyMeter)
    }))
    setCurrentMeterReadings(normalizedReadings)
  }, [meterReadings])


  useEffect(() => {
    // console.log('selectedAsset', selectedAsset)
    // console.log('selectedDate', selectedDate)
    // console.log('selectedDateTime', moment(props.selectedDateTime).valueOf())

    if (selectedAsset) {
      if (isDateBased && !selectedDate) {
        message.error('Please select a date')
      } else {
        props.getAssetMeterDetail(selectedAsset, selectedDate ? moment(selectedDate).valueOf() : 0)
      }
    }
  }, [selectedAsset, selectedDate])

  useEffect(() => {
    // console.log('assetMeters', props.assetMeters)
    props.setCurrentAssetMeters(props.assetMeters)

    // Default the "Mark meter as faulty" checkbox for any meter that is currently flagged
    // faulty on its Meter record, driven by the ENTRY DATE relative to the moment the meter
    // became faulty (meter.faultyMeterData.datetime):
    //   - entry on/after the fault point  -> default faulty (tick)
    //   - entry before the fault point     -> default good  (untick)
    // This mirrors the backend faulty window [faultyMeterData.datetime, cleared). We drive it
    // BOTH ways (and update currentMeterReadings via handleFaultyMeterChange) so switching the
    // date re-applies the correct default even if the checkbox remounts during the re-fetch.
    // The effect only re-runs when the meter list or the selected date changes, so a manual
    // tick/untick the user makes within the same date is preserved. Meters not flagged faulty
    // on their record are never auto-touched here.
    const entryTs = selectedDate ? moment(selectedDate).valueOf() : null
    ;(props.assetMeters || []).forEach(item => {
      if (!item || item.isFaultyMeter !== true) {
        return
      }
      const meterId = getMeterId(item && item._id)
      const faultyTs = item.faultyMeterData && item.faultyMeterData.datetime
      // Legacy meters without a recorded fault datetime keep the old always-faulty default.
      // entryTs === null (no date selected yet) => leave the checkbox untouched.
      const shouldDefaultFaulty = faultyTs == null
        ? true
        : (entryTs != null ? entryTs >= faultyTs : null)
      if (shouldDefaultFaulty === null) {
        return
      }
      const current = !!form.getFieldValue(`isFaultyMeter[${meterId}]`)
      if (current !== shouldDefaultFaulty) {
        handleFaultyMeterChange(item, shouldDefaultFaulty)
      }
    })
  }, [props.assetMeters, selectedDate])

  // const filteredMeterUnits = selectedAsset && selectedAssetModel
  //   ? newMeterUnits.filter(mtr => (selectedAssetModel.meters || []).map(mtr => mtr._id).includes(mtr._id))
  //   : newMeterUnits

  // const handleSubmit = () => {
  //   if (unit && reading) props.onCreate({ unit, reading })
  // }

  // const handleChange = (type, value) => {
  //   if (type === 'unit') setUnit(value)
  //   if (type === 'reading') setReading(value)

  // }

  useEffect(() => {
    // console.log('currentMeterReadings', currentMeterReadings)
    if (handleChange) handleChange('meterReading', currentMeterReadings)
  }, [currentMeterReadings])

  const preventWheelValueChange = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    if (event && event.stopPropagation) {
      event.stopPropagation()
    }
    if (event && event.currentTarget && event.currentTarget.blur) {
      event.currentTarget.blur()
    }
    return false
  }

  const handleMeterReadingChange = ({ name, unit, meter, reading, isFaultyMeter }, shouldValidate = false, item = null) => {
    // console.log('name', name)
    // console.log('unit', unit)
    // console.log('meter', meter)
    // console.log('reading', reading)

    setCurrentMeterReadings((prev) => {
      const prevReading = [...(prev || [])]
      const index = prevReading.findIndex(r => getMeterId(r.meter) === getMeterId(meter))
      if (index !== -1) {
        prevReading[index].reading = reading
        prevReading[index].isFaultyMeter = !!isFaultyMeter
      } else {
        prevReading.push({ meter: getMeterId(meter), reading, unit, name, isFaultyMeter: !!isFaultyMeter })
      }
      return prevReading
    })

    if (shouldValidate && !isFaultyMeter) {
      const fid = props._id || null
      if (selectedAsset && selectedDate) {
        props.getVerificationReadingRecord(selectedAsset, meter, moment(selectedDate).valueOf(), fid)
      } else {
        form.setFields({
          [`meterReading[${meter}]`]: {
            value: 0,
            errors: ['Please select an asset'],
          },
        })
        message.error('Please select an asset / date')
      }
    }
  }

  const handleFaultyMeterChange = (item, checked) => {
    const meterId = getMeterId(item && item._id)
    form.setFieldsValue({
      [`isFaultyMeter[${meterId}]`]: checked
    })
    if (checked) {
      form.setFieldsValue({
        [`meterReading[${meterId}]`]: null
      })
      form.setFields({
        [`meterReading[${meterId}]`]: {
          value: null,
          errors: []
        }
      })
    }
    handleMeterReadingChange({
      name: item && item.meterType && item.meterType.name,
      unit: item && item.meterType && item.meterType._id,
      meter: meterId,
      reading: checked ? null : form.getFieldValue(`meterReading[${meterId}]`),
      isFaultyMeter: checked
    }, false)
  }

  useEffect(() => {
    // console.log('verificationReadingRecord', props.verificationReadingRecord)
    const { previous, next } = props.verificationReadingRecord || {}
    if (previous || next) {
      // console.log('previous', previous)
      // console.log('next', next)
      // check the state reading is betwen previous and next
      const meterType = previous && previous.meterType ? previous.meterType : next && next.meterType ? next.meterType : null
      let isValid = true

      if (meterType) {
        const meterReading = currentMeterReadings && currentMeterReadings.find(r => r.unit === meterType)
        if (meterReading) {
          if (previous && previous.reading) {
            // Reading may be equal to or greater than the previous reading.
            if (previous.meter.toString() === meterReading.meter.toString()) {
              isValid = isValid && meterReading.reading >= previous.reading
            } else {
              isValid = isValid && (meterReading.reading + previous.calculatedReading) >= previous.calculatedReading
            }
            if (!isValid) {
              form.setFields({
                [`meterReading[${meterReading.meter}]`]: {
                  value: 0,
                  errors: ['Reading should be greater than or equal to previous reading ' + previous.reading],
                }
              })
              message.error('Reading should be greater than or equal to previous reading ' + previous.reading)
              setCurrentMeterReadings((prev) => {
                const prevReading = [...prev]
                const index = prevReading.findIndex(r => r.meter === meterReading.meter)
                if (index !== -1) {
                  prevReading[index].reading = 0
                }
                return prevReading
              })
            } else {
              // remove error
              // form.resetFields([`meterReading[${meterReading.meter}]`])
            }
          }

          if (next && next.reading) {
            if (next.meter.toString() === meterReading.meter.toString()) {
              isValid = isValid && meterReading.reading <= next.reading
            } else {
              // be a valid entry
              // isValid = isValid && (meterReading.reading + previous.calculatedReading) <= next.reading
            }

            if (!isValid) {
              // console.log('reading is not valid', meterReading.reading, next.reading)
              // form.setFields([{ name: `meterReading[${meter}]`, errors: ['Reading should be less than next reading ' + next.reading] }])
              form.setFields({
                [`meterReading[${meterReading.meter}]`]: {
                  value: 0,
                  errors: ['Reading should be less than or equal to next reading ' + next.reading],
                }
              })
              message.error('Reading should be less than or equal to next reading ' + next.reading)
              setCurrentMeterReadings((prev) => {
                const prevReading = [...prev]
                const index = prevReading.findIndex(r => r.meter === meterReading.meter)
                if (index !== -1) {
                  prevReading[index].reading = 0
                }
                return prevReading
              })
            }
          }
        }
      }
      // console.log('isValid', isValid)

    }
  }, [props.verificationReadingRecord])

  // Guard against duplicate meter entries in the incoming list (e.g. an asset that has
  // two meters of the same meterType, or a stale/merged list arriving mid-fetch). Render
  // each meter once, keyed by the stable string meterId, so React never sees two children
  // with the same key and the `meterReading[<id>]` / `isFaultyMeter[<id>]` form fields are
  // not registered twice for the same meter.
  const uniqueAssetMeters = React.useMemo(() => {
    const seen = new Set()
    return (props.assetMeters || []).filter(item => {
      const id = getMeterId(item && item._id)
      if (!id || seen.has(id)) return false
      seen.add(id)
      return true
    })
  }, [props.assetMeters])

  return (
    <div
      style={{
        marginTop: '10px',
        marginBottom: '10px',
        border: '1px dashed #000',
        padding: '20px',
        borderRadius: '9px',
        display: visible ? 'block' : 'none'
      }}
    >
      <p>
        <Icon type='bg-colors' /> Meter Reading
      </p>

      {uniqueAssetMeters.map(item => {
        const meterId = getMeterId(item && item._id)
        const readingValue = currentMeterReadings && currentMeterReadings.find(r => getMeterId(r.meter) === meterId)
        const isFaultyMeter = !!(readingValue && readingValue.isFaultyMeter)

        // console.log('item', item)
        // console.log('reading', readingValue)
        return (
          <div key={meterId}>
            <Form.Item style={{ marginBottom: '8px' }}>
              {getFieldDecorator(`isFaultyMeter[${meterId}]`, {
                valuePropName: 'checked',
                initialValue: isFaultyMeter
              })(
                <Checkbox onChange={(e) => handleFaultyMeterChange(item, e.target.checked)}>
                  Mark meter as faulty
                </Checkbox>
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator(`meterReading[${meterId}]`, {
                rules: [{
                  validator: (_, value, callback) => {
                    const faulty = form.getFieldValue(`isFaultyMeter[${meterId}]`)
                    if (faulty) {
                      callback()
                      return
                    }
                    if (value === '' || value === null || value === undefined) {
                      callback('Meter reading is required')
                      return
                    }
                    const numericValue = Number(value)
                    if (Number.isNaN(numericValue) || numericValue <= 0) {
                      callback('Meter reading must be greater than 0')
                      return
                    }

                    // HOURS meter validation:
                    // use calendar day span instead of exact elapsed hours.
                    // allowed increment = (dayDiff + 1) * 24
                    // Only validate if: 1) Meter type is HOURS, 2) Same meter as previous record
                    const meterTypeName = item && item.meterType && item.meterType.name
                    if (meterTypeName && meterTypeName.toUpperCase() === 'HOURS' && props.verificationReadingRecord) {
                      const { previous } = props.verificationReadingRecord
                      // Check if it's the SAME meter (compare meter IDs)
                      const isSameMeter = previous && previous.meter &&
                        previous.meter.toString() === meterId.toString()

                      if (isSameMeter && previous.reading !== undefined && previous.reading !== null && previous.readingDateTs) {
                        const prevDate = moment(previous.readingDateTs).startOf('day')
                        const currentDate = moment(selectedDate).startOf('day')
                        const dayDifference = Math.max(currentDate.diff(prevDate, 'days'), 0)
                        const allowedHoursByDaySpan = (dayDifference + 1) * 24
                        const maxAllowedReading = Number(previous.reading) + allowedHoursByDaySpan

                        if (numericValue > maxAllowedReading) {
                          callback(`Meter reading (${numericValue}) cannot exceed previous reading (${previous.reading}) + allowed hours (${allowedHoursByDaySpan.toFixed(2)}) = ${maxAllowedReading.toFixed(3)}`)
                          return
                        }
                      }
                    }

                    callback()
                  }
                }],
                initialValue: isFaultyMeter ? null : (readingValue ? readingValue.reading : null)
              })(
                <Input
                  key={meterId}
                  addonBefore={item.meterNo}
                  addonAfter={item.meterType && item.meterType.name}
                  type='number'
                  disabled={isFaultyMeter}
                  onWheel={preventWheelValueChange}
                  onWheelCapture={preventWheelValueChange}
                  onMouseWheel={preventWheelValueChange}
                  // value={reading && reading[item._id]}
                  onChange={e =>
                    handleMeterReadingChange({
                      name: item && item.meterType && item.meterType.name,
                      unit: item && item.meterType && item.meterType._id,
                      meter: meterId,
                      reading: e.target.value,
                      isFaultyMeter: form.getFieldValue(`isFaultyMeter[${meterId}]`)
                    }, false, item)
                  }
                  onBlur={e =>
                    {
                      const nextFocused = e && e.relatedTarget;
                      const isSubmitButtonFocus = !!(nextFocused && (
                        nextFocused.type === 'submit' ||
                        (nextFocused.getAttribute && nextFocused.getAttribute('data-role') === 'fuel-save-btn')
                      ));
                      handleMeterReadingChange({
                        name: item && item.meterType && item.meterType.name,
                        unit: item && item.meterType && item.meterType._id,
                        meter: meterId,
                        reading: e.target.value,
                        isFaultyMeter: form.getFieldValue(`isFaultyMeter[${meterId}]`)
                      }, !isSubmitButtonFocus, item)
                    }
                  }
                />
              )}
            </Form.Item>
          </div>
        )
      })}
    </div>
  )
})

const mapStateToProps = ({ auth, meter, commonData, assetReading }) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    lastReadingWithTime: assetReading.lastReadingWithTime,
    assetMeters: meter.assetMeters,
    verificationReadingRecord: assetReading.verificationReadingRecord
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getLastReadingTimeBased,
    getAssetMeterDetail,
    getVerificationReadingRecord
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(Mileage);
